module.exports = __webpack_public_path__ + "static/media/Screenshot 2022-06-30 at 11.54.23 AM.67c3fcb6.png";